import React from 'react'
import companyLogo from './jbm1.gif'
import companyLogo1 from './tree.jpg'
import hec from './hec.png'
import bal from './cancer.jpg'
import bal1 from './cancer1.jpg'
import bal2 from './research.jpg'
import Iframe from  'react-iframe'

import "./Home.css"
export default function Home() {
  return (
    <div className='homePage'>
       
<div className='head' >
  <div className="headfront" style={{display:"flex", flexDirection:"column"}}>
  <div className='pheader'> <div className='pheader1'><h1>CENTER FOR BIORESOURCE RESEARCH</h1> <div class="article"  >
    <h3 style={{fontFamily:"sans-serif", fontSize:"16px", fontWeight:"300"}}>Name Of Education & Research
     CBR is an private organization run by motivated scientists with focus on research actions pertaining to conservation of biological resources Multidisciplinary based organization with urge for quality research and dissemination of results to stakeholders that support conservation actions through meaningful collaborations with potential partners (scientists and conservationists)</h3>
   </div></div></div>
  <div className="headtop" style={{fontFamily:"sans-serif",display:"flex",justifyContent:"start",alignItems:"start"}}>
 
  </div>
  
 
  </div>
</div>


<div className='flex'> 
 
  <div><h1 className="logo"> <a target="_blank" href="https://corescholar.libraries.wright.edu/jbm"><img src={companyLogo} width={200} height={200} alt="CBR"/></a> 
								<div style={{fontSize:"18px", fontFamily:"sans-serif"}}>
                  		Journal of Bioresource Management
                  </div>
								</h1></div>
                <div><h1 className="logo"> <a target="_blank" href="https://corescholar.libraries.wright.edu/jbm"><img src={bal1} width={400} height={350} alt="CBR"/></a> 
								<div style={{fontSize:"18px", fontFamily:"sans-serif"}}>
                  	
                  </div>
								</h1></div>

                <div><h1 className="logo"> <a target="_blank" href="https://corescholar.libraries.wright.edu/jbm"><img src={bal} width={400} height={350} alt="CBR"/></a> 
								<div style={{fontSize:"18px", fontFamily:"sans-serif"}}>
                  	
                  </div>
								</h1></div>
</div>

<div className='iframes'> 
  <div className='box white'>
    <Iframe className='iframvideo'  url='https://www.youtube.com/embed/RsRnnpcexOg' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen styles={{width:"700vw",height:"auto"}}></Iframe>
    <div class="mask">
                            <a style={{textDecoration:"none",color:"black",fontWeight:"600"}} href="https://youtu.be/RsRnnpcexOg" class="info">CBR CHANNEL</a>
                        </div>
  </div>
  <div className='box green'><div className='green'><a target="_blank" href="https://corescholar.libraries.wright.edu/jbm"><img src={bal2} width={600} height={405} alt="CBR"/></a> </div></div>
							
</div>
            
  </div>

    

  )
}
